import {
	shouldShowCheckPayments,
	shouldShowECheckReportingPage,
	shouldShowInstallmentPlans,
	shouldShowStoredCardsReport as practiceShouldShowStoredCards,
	isBravaPractice,
	isTerminalTippingEnabled
} from '../util/practice'
import {
	shouldShowCheckPayments as consolidatorShouldShowCheckPayments,
	shouldShowRefundRequest,
	shouldHideReconciliation,
	shouldHidePayoutsPage,
	shouldShowMonthlyStatementsPage,
	shouldShowStoredCardsReport as consolidatorShouldShowStoredCards,
	showDailyCashCountPage
} from '../util/consolidator'

export const getReportingSectionProps = (
	practice: IPractice,
	consolidator: IConsolidator | undefined
): ReportingSectionProps =>
	({
		showCheckPayments: shouldShowCheckPayments(
			practice,
			consolidatorShouldShowCheckPayments(consolidator)
		),
		showInstallmentPlans: shouldShowInstallmentPlans(practice),
		showSavedCards:
			practiceShouldShowStoredCards(practice) ?? consolidatorShouldShowStoredCards(consolidator),
		showECheckReportingPage: shouldShowECheckReportingPage(practice),
		showRefundRequests: shouldShowRefundRequest(consolidator),
		hideReconciliation: shouldHideReconciliation(consolidator),
		hidePayoutsPage: shouldHidePayoutsPage(consolidator),
		showMonthlyStatements:
			isBravaPractice(practice) === false &&
			(!consolidator?.id || shouldShowMonthlyStatementsPage(consolidator)),
		showDailyCashCountPage: showDailyCashCountPage(consolidator),
		showTipReport: Boolean(isTerminalTippingEnabled(practice, consolidator))
	}) as ReportingSectionProps
